// GETTERS
export const GET_IN_PROGRESS_CONTENT_ITEMS = 'GET_IN_PROGRESS_CONTENT_ITEMS';
export const GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS = 'GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS';
export const GET_FAILED_SCRAPED_CONTENT_ITEMS = 'GET_FAILED_SCRAPED_CONTENT_ITEMS';
export const GET_CONTENT_ITEM_DISPLAY_PROPERTIES = 'GET_CONTENT_ITEM_DISPLAY_PROPERTIES';
export const GET_CURRENT_ASSET_NAMES = 'GET_CURRENT_ASSET_NAMES';
export const GET_CONTENT_ITEM_ACTIVE_STATE = 'GET_CONTENT_ITEM_ACTIVE_STATE';
export const GET_ARTICLE_BY_ID = 'GET_ARTICLE_BY_ID';
export const GET_ARTICLE_BY_UUID = 'GET_ARTICLE_BY_UUID';
export const GET_ARTICLES = 'GET_ARTICLES';
export const GET_CREATIVES_FULL_LIST_PROPERTIES = 'GET_CREATIVES_FULL_LIST_PROPERTIES';
export const GET_ACTIVE_CREATIVES = 'GET_ACTIVE_CREATIVES';
export const GET_CREATIVES_DEFINED = 'GET_CREATIVES_DEFINED';
export const GET_TEMPLATE_OPTIONS = 'GET_TEMPLATE_OPTIONS';
export const GET_ACTIVE_CREATIVE_TEMPLATES = 'GET_ACTIVE_CREATIVE_TEMPLATES';
export const GET_TEMPLATE_NAME_BY_ID = 'GET_TEMPLATE_NAME_BY_ID';
export const GET_ANNOTATIONS = 'GET_ANNOTATIONS';
export const GET_CURRENT_SELECTED_CREATIVE_DISPLAY_COPY = 'GET_CURRENT_SELECTED_CREATIVE_DISPLAY_COPY';
export const GET_CURRENT_SELECTED_CREATIVE = 'GET_CURRENT_SELECTED_CREATIVE';
export const GET_CURRENT_SELECTED_CREATIVE_PROPERTIES = 'GET_CURRENT_SELECTED_CREATIVE_PROPERTIES';
export const GET_CONTENT_ITEMS_WITH_MISSED_CREATIVES = 'GET_CONTENT_ITEMS_WITH_MISSED_CREATIVES';

// ACTIONS
// eslint-disable-next-line import/prefer-default-export
export const FETCH_FEED = 'FETCH_FEED';
export const EXPORT_ARTICLES_AS_CSV = 'EXPORT_ARTICLES_AS_CSV';
export const FETCH_ARTICLES = 'FETCH_ARTICLES';
export const FETCH_SHOWCASE_ARTICLES = 'FETCH_SHOWCASE_ARTICLES';
export const FETCH_SHOWCASE_CONTENT_ITEMS = 'FETCH_SHOWCASE_CONTENT_ITEMS';
export const NEW_FETCH_CONTENT_SCRAPES = 'NEW_FETCH_CONTENT_SCRAPES';
export const NEW_FETCH_CONTENT_SCRAPES_ONCE = 'NEW_FETCH_CONTENT_SCRAPES_ONCE';
export const NEW_FETCH_CONTENT_ITEMS = 'NEW_FETCH_CONTENT_ITEMS';
export const NEW_FETCH_DISPLAY_PROPERTIES = 'NEW_FETCH_DISPLAY_PROPERTIES';
export const FETCH_CONTENT_ITEM = 'FETCH_CONTENT_ITEM';
export const FETCH_LANGUAGES = 'FETCH_LANGUAGES';
export const PATCH_LANGUAGES = 'PATCH_LANGUAGES';
export const SCRAPE_CONTENT = 'SCRAPE_CONTENT';
export const RESCRAPE_CONTENT = 'RESCRAPE_CONTENT';
export const SCRAPE_FILE_CONTENT = 'SCRAPE_FILE_CONTENT';
export const UPLOAD_URLS_SPREADSHEET_FOR_SCRAPE = 'UPLOAD_URLS_SPREADSHEET_FOR_SCRAPE';
export const SCRAPED_CONTENT = 'SCRAPED_CONTENT';
export const PATCH_CONTENT_ITEM = 'PATCH_CONTENT_ITEM';
export const FETCH_FEED_CONTENT_ITEMS = 'FETCH_FEED_CONTENT_ITEMS';
export const FETCH_FILTERED_FEED_CONTENT_ITEMS = 'FETCH_FILTERED_FEED_CONTENT_ITEMS';
export const FETCH_ALL_CONTENT_ITEMS_BY_FEED_ID = 'FETCH_ALL_CONTENT_ITEMS_BY_FEED_ID';
export const FETCH_FEED_CONTENT_ITEMS_BY_ID = 'FETCH_FEED_CONTENT_ITEMS_BY_ID';
export const FETCH_CONTENT_ITEMS = 'FETCH_CONTENT_ITEMS';
export const FETCH_LIVE_CONTENT_ITEMS = 'FETCH_LIVE_CONTENT_ITEMS';
export const SAVE_CONTENT_EDITOR_CHANGES = 'SAVE_CONTENT_EDITOR_CHANGES';
export const UPDATE_CONTENT_ITEM = 'UPDATE_CONTENT_ITEM';
export const DELETE_CONTENT_ITEM = 'DELETE_CONTENT_ITEM';
export const GET_TEMPLATE_BY_ID = 'GET_TEMPLATE_BY_ID';
export const FETCH_CREATIVE_TEMPLATES = 'FETCH_CREATIVE_TEMPLATES';
export const FETCH_CREATIVE_TEMPLATES_BY_CAMPAIGNIDS = 'FETCH_CREATIVE_TEMPLATES_BY_CAMPAIGNIDS';
export const POST_CREATIVES = 'POST_CREATIVES';
export const POST_CREATIVES_WITH_TYPE = 'POST_CREATIVES_WITH_TYPE';
export const PATCH_CREATIVE = 'PATCH_CREATIVE';
export const PATCH_CREATIVE_PROPERTIES = 'PATCH_CREATIVE_PROPERTIES';
export const PUT_CREATIVES = 'PUT_CREATIVES';
export const PUT_CREATIVES_WITH_TYPE = 'PUT_CREATIVES_WITH_TYPE';
export const UPLOAD_CREATIVE_DISPLAY_IMAGE = 'UPLOAD_CREATIVE_DISPLAY_IMAGE';
export const SWAP_CREATIVE_DISPLAY_IMAGE = 'SWAP_CREATIVE_DISPLAY_IMAGE';
export const DELETE_CREATIVE_DISPLAY_IMAGE = 'DELETE_CREATIVE_DISPLAY_IMAGE';
export const FETCH_EXISTING_CONTENT_SCRAPES = 'FETCH_EXISTING_CONTENT_SCRAPES';
export const FETCH_EXISTING_CREATIVES = 'FETCH_EXISTING_CREATIVES';
export const FETCH_CREATIVE_CONTENT_STATES = 'FETCH_CREATIVE_CONTENT_STATES';
export const PATCH_LOGO_IMAGE = 'PATCH_LOGO_IMAGE';
export const DELETE_LOGO_IMAGE = 'DELETE_LOGO_IMAGE';
export const RESET_CREATIVE_PROPERTIES = 'RESET_CREATIVE_PROPERTIES';
export const FETCH_CONTENT_COMMENTS = 'FETCH_CONTENT_COMMENTS';
export const FETCH_CONTENT_COMMENTS_COUNT = 'FETCH_CONTENT_COMMENTS_COUNT';
export const POST_CONTENT_COMMENT = 'POST_CONTENT_COMMENT';
export const SET_CURRENT_ANNOTATION = 'SET_CURRENT_ANNOTATION';
export const REMOVE_CURRENT_ANNOTATION = 'REMOVE_CURRENT_ANNOTATION';
export const UPDATE_CURRENT_COMMENTS = 'UPDATE_CURRENT_COMMENTS';
export const TOGGLE_ARTICLE_SHARED_STATE = 'TOGGLE_ARTICLE_SHARED_STATE';
export const TOGGLE_ALL_CONTENT_SHARED = 'TOGGLE_ALL_CONTENT_SHARED';
export const SELECT_ONLY_DRAFT = 'SELECT_ONLY_DRAFT';
export const FETCH_SHARED_COUNT = 'FETCH_SHARED_COUNT';
export const FETCH_SHARED_CONTENT_ITEMS = 'FETCH_SHARED_CONTENT_ITEMS';
export const FETCH_CREATIVE_TEMPLATE_BY_ID = 'FETCH_CREATIVE_TEMPLATE_BY_ID';
export const FETCH_CONTENT_DISPLAY_COPY = 'FETCH_CONTENT_DISPLAY_COPY';
export const UPDATE_CONTENT_DISPLAY_COPY = 'UPDATE_CONTENT_DISPLAY_COPY';
export const SAVE_CUSTOM_PROPERTIES = 'SAVE_CUSTOM_PROPERTIES';
export const FETCH_CUSTOM_PROPERTY_TYPES = 'FETCH_CUSTOM_PROPERTY_TYPES';
export const UPDATE_CURRENT_SELECTED_CREATIVE_ID = 'UPDATE_CURRENT_SELECTED_CREATIVE_ID';
export const FETCH_EXISTING_CREATIVES_AS_SHAREE = 'FETCH_EXISTING_CREATIVES_AS_SHAREE';
export const GET_CREATIVES_CARROUSEL_COVERED = 'GET_CREATIVES_CARROUSEL_COVERED';
export const SET_CONTENT_ITEM_SCHEDULE = 'SET_CONTENT_ITEM_SCHEDULE';
export const FETCH_CONTENT_STATES = 'FETCH_CONTENT_STATES';
export const FETCH_IMAGE_ASSET_NAMES = 'FETCH_IMAGE_ASSET_NAMES';
export const FETCH_IMAGE_ASSET = 'FETCH_IMAGE_ASSET';
export const DELETE_IMAGE_ASSET = 'DELETE_IMAGE_ASSET';

// MUTATIONS
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_IN_PROGRESS_CONTENT_SCRAPES = 'SET_IN_PROGRESS_CONTENT_SCRAPES';
export const NEW_SET_SCRAPED_CONTENT = 'NEW_SET_SCRAPED_CONTENT';
export const NEW_SET_CONTENT_ITEMS = 'NEW_SET_CONTENT_ITEMS';
export const NEW_SET_CONTENT_ITEMS_DISPLAY_PROPERTIES = 'NEW_SET_CONTENT_ITEMS_DISPLAY_PROPERTIES';
export const UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES = 'UPDATE_CONTENT_ITEMS_DISPLAY_PROPERTIES';
export const SET_LOADING_ARTICLES = 'SET_LOADING_ARTICLES';
export const SET_LOADING_ARTICLES_SECTION = 'SET_LOADING_ARTICLES_SECTION';
export const DELETE_CONTENT_SCRAPES = 'DELETE_CONTENT_SCRAPES';
export const DELETE_CONTENT_ITEMS = 'DELETE_CONTENT_ITEMS';
export const SET_CONTENT_SCRAPE_ID = 'SET_CONTENT_SCRAPE_ID';
export const SET_SCRAPED_CONTENT = 'SET_SCRAPED_CONTENT';
export const SET_CONTENT_ITEMS = 'SET_CONTENT_ITEMS';
export const ADD_CONTENT_ITEM = 'ADD_CONTENT_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const SET_CREATIVE = 'SET_CREATIVE';
export const SET_ALL_DISPLAY_COPY = 'SET_ALL_DISPLAY_COPY';
export const SET_CUSTOM_PROPERTY_TYPES = 'SET_CUSTOM_PROPERTY_TYPES';
export const UPDATE_DISPLAY_COPY = 'UPDATE_DISPLAY_COPY';
export const SET_CREATIVES = 'SET_CREATIVES';
export const SET_ACTIVE_CREATIVES = 'SET_ACTIVE_CREATIVES';
export const SET_CREATIVES_SIZES = 'SET_CREATIVES_SIZES';
export const UPDATE_CREATIVES_PROPERTIES_BY_ID = 'UPDATE_CREATIVES_PROPERTIES_BY_ID';
export const SET_CREATIVE_TEMPLATES = 'SET_CREATIVE_TEMPLATES';
export const RESET_CONTENT_ITEM = 'RESET_CONTENT_ITEM';
export const SET_FEED_ID = 'SET_FEED_ID';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export const SET_CONTENT_TOTAL_ITEMS = 'SET_CONTENT_TOTAL_ITEMS';
export const SET_CONTENT_TOTAL_PUBLISHED_ITEMS = 'SET_CONTENT_TOTAL_PUBLISHED_ITEMS';
export const SET_CREATIVE_MODE = 'SET_CREATIVE_MODE';
export const SET_COMMENTS_COUNT = 'SET_COMMENTS_COUNT';
export const INCREMENT_COMMENTS_COUNT = 'INCREMENT_COMMENTS_COUNT';
export const SET_IS_SELF_SERVICE_CONTENT = 'SET_IS_SELF_SERVICE_CONTENT';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const TOGGLE_ANNOTATIONS = 'TOGGLE_ANNOTATIONS';
export const UPDATE_CURRENT_ANNOTATION_STATE = 'UPDATE_CURRENT_ANNOTATION_STATE';
export const UPDATE_CURRENT_ANNOTATION = 'UPDATE_CURRENT_ANNOTATION';
export const CLEAR_CURRENT_COMMENTS = 'CLEAR_CURRENT_COMMENTS';
export const SET_SHARED_COUNT = 'SET_SHARED_COUNT';
export const SET_FEED_CONTENT_ITEMS = 'SET_FEED_CONTENT_ITEMS';
export const SET_SHARED_CONTENT_ITEMS = 'SET_SHARED_CONTENT_ITEMS';
export const SET_CONTENT_LIST_TYPE = 'SET_CONTENT_LIST_TYPE';
export const SET_CREATIVE_CONTENT_STATES = 'SET_CREATIVE_CONTENT_STATES';
export const RESET_CONTENT_ITEMS_QUERY_PARAMS = 'RESET_CONTENT_ITEMS_QUERY_PARAMS';
export const SET_CONTENT_STATES = 'SET_CONTENT_STATES';
export const SET_IMAGE_ASSET_NAMES = 'SET_IMAGE_ASSET_NAMES';
export const REMOVE_IMAGE_ASSET_NAME = 'REMOVE_IMAGE_ASSET_NAME';
export const SET_ADD_UNITS_SELECTED = 'SET_ADD_UNITS_SELECTED';
export const SET_CREATIVE_TYPE_SELECTED = 'SET_CREATIVE_TYPE_SELECTED';
export const CLEAR_CREATIVES = 'CLEAR_CREATIVES';

// MUTATIONS + ACTIONS
export const SET_CONTENT_ITEM_PUBLISHING_STATE = 'SET_CONTENT_ITEM_PUBLISHING_STATE';
export const UPDATE_A_CREATIVE_CONTENT_STATE = 'UPDATE_A_CREATIVE_CONTENT_STATE';
export const SET_SELECTED_ARTICLE_UUID = 'SET_SELECTED_ARTICLE_UUID';
export const SET_FILTERS_QUERY = 'SET_FILTERS_QUERY';
export const SET_CONTENT_ITEM_QUERY_PARAM = 'SET_CONTENT_ITEM_QUERY_PARAM';
export const SET_CONTENT_EDITOR_ARTICLE = 'SET_CONTENT_EDITOR_ARTICLE';
export const TRIGGER_CREATIVE_RERENDER = 'TRIGGER_CREATIVE_RERENDER';
export const SET_EMAIL_USER_ON_SCRAPE_COMPLETION = 'SET_EMAIL_USER_ON_SCRAPE_COMPLETION';
export const SET_CONTENT_ITEMS_URLS_CHANGED = 'SET_CONTENT_ITEMS_URLS_CHANGED';
export const SET_KILL_CURRENT_SCRAPING_FETCH = 'SET_KILL_CURRENT_SCRAPING_FETCH';
export const SET_SELECTED_CREATIVE_ID = 'SET_SELECTED_CREATIVE_ID';
export const SET_CREATIVE_BOTTOM_PANEL_IS_OPEN = 'SET_CREATIVE_BOTTOM_PANEL_IS_OPEN';
export const SET_CREATIVE_SIDEBAR_IS_OPEN = 'SET_CREATIVE_SIDEBAR_IS_OPEN';
export const DELETE_ARTICLES = 'DELETE_ARTICLES';
export const TRIGGER_ANNOTATION = 'TRIGGER_ANNOTATION';
export const SET_IS_SIDEBAR_INPUT_FOCUSED = 'SET_IS_SIDEBAR_INPUT_FOCUSED';
